/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal.m-grammar-guide #mobile-grammar-guide{width:100%}"];
export { styles as styles };
//# sourceMappingURL=mobile-grammar-guide.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/mobile-grammar-guide/mobile-grammar-guide.component.scss.shim.ngstyle.js
// module id = 1457
// module chunks = 27 28 29